import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'
import CustomTheme from 'theme'

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.5rem;
    background-color: #fff;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin: 0;
        padding-top: 1.5rem;
        position: sticky;
    }
    .footer__button {
        width: auto;
        margin: 0;

        &--submit {
            justify-self: flex-end;
        }

        &--disabled,
        &--disabled:hover,
        &--disabled:focus {
            cursor: auto;
            color: var(--theme-ui-colors-grays-60);
            background-color: var(--theme-ui-colors-grays-80);
        }
    }

    ${CustomTheme.breakPoint.tablet} {
        padding-top: 2.5rem;
    }
`
